import useMediaQuery from './hooks/use-media-query';

export const DEFAULT_FONTS = ['Poppins', 'Roboto', 'Lato', 'Noto Sans', 'Noto', 'Open Sans', 'sans-serif'];

export function useIsDesktopRouting() {
  return useMediaQuery('(min-width: 700px)');
}
